import styled from '@emotion/styled';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Drawer from '@mui/material/Drawer';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import ListItem from '@mui/material/ListItem';

export const StyledTableCell = styled(TableCell)`
  background-color: #f5f5f5;
  font-weight: bold;
`;

export const StyledTableRow = styled(TableRow)`
  :nth-of-type(even) {
    background-color: #f5f5f5;
  }
`;

export const StyledDataWrapper = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
  align-self: baseline;
  width: 100%;

  & .MuiListItem-gutters {
    padding-left: 0;
  }
`;

export const StyledPageContainer = styled(Grid)(
  ({theme}) => `
  margin-top: ${theme.variables.appBarHeight};
  padding-left: ${theme.variables.drawerWidth};
`
);

export const StyledDrawer = styled(Drawer)(
  ({theme}) => `
  & .MuiPaper-root {
    min-width: ${theme.variables.drawerWidth};
    z-index: ${theme.variables.appBarZIndex - 1};
  }
`
);

export const StyledReportWrapper = styled(Card)`
  width: 90vw;
  box-shadow: 3;
`;

export const StyledAppBar = styled(AppBar)(
  ({theme}) => `
  height: calc(${theme.variables.appBarHeight} + env(safe-area-inset-top));
  z-index: ${theme.variables.appBarZIndex};
  padding-top: env(safe-area-inset-top);
`
);

export const StyledListItem = styled(ListItem)(
  ({theme, isactive}) => `
 
  width: auto;
  background-color: ${isactive === 'true' ? theme.palette.primaryBackground.main : 'auto'};
  border-radius: 5px;
  margin: 8px;

  & .MuiListItemIcon-root {
    color: ${isactive === 'true' ? theme.palette.primary.main : theme.palette.iconColor.main};
  }
 
  & .MuiListItemText-root {
    color: ${isactive === 'true' ? theme.palette.primary.main : theme.palette.secondaryTextColor.main};
  }

  & .MuiListItemText-primary {
    font-weight: bolder;
  }
`
);

export const StyledSearchFormWrapper = styled(Card)`
  width: 90vw;
  box-shadow: none;
`;
